import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home.vue'
import Login from '@/pages/login.vue'
import ListDown from '@/pages/homeChild/listDown.vue'
import Search from '@/pages/celebrities/search.vue'

export default new Router({
  base:'/download/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect:'/list_down',
      children:[
      	{
      		path: 'list_down',
        	name: 'listDown',
        	component: ListDown
      	}
      ]
    },{
      path: '/login',
        name: 'login',
        component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js